import {Stub} from "../feed/components";

const HelpPage = () => {
    return <Stub placeholder={'HelpPage'} />
}

export default HelpPage;
